// extracted by mini-css-extract-plugin
export var printerCard = "_99-1";
export var printerCardConfigured = "_99-2";
export var printerCardError = "_99-3";
export var printerCardsContainer = "_99-0";
export var printerIcon = "_99-8";
export var printerIconConfigured = "_99-5";
export var printerIconContainer = "_99-4";
export var printerIconError = "_99-6";
export var printerIconUnconfigured = "_99-7";